module.exports = __webpack_public_path__ + "static/capitalization-splash-low.d3281c60.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/capitalization-splash-low.jpg
// module id = 874
// module chunks = 258070730206521